export const LANDING = '/';
export const GEN_ART = '/collect';
export const PROFILE = '/me';
export const PUBLIC_FEED = '/swarm';
export const PERMALINK = '/artwork/:artworkid';
export const USER_PUBLIC = '/collector/:userid';
export const MINT_ART= "/mint/:artworkid";